<main class="container">
    <div class="row">
        <div class="col-12">
            <div class="formulario">
                <form [formGroup]="formUsuario" (ngSubmit)="cadastrar()">
                    <h1>Cadastro de Usuário</h1>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <label class="form-group" id="label-input">
                                    <span>Nome:</span>
                                    <input type="text" formControlName="vc_nome" class="input form-control" name="text"
                                        required>
                                    <ng-container *ngIf="formUsuario.controls.vc_nome.touched">
                                        <p class="msg-erro" *ngIf="formUsuario.controls.vc_nome.errors">Campo
                                            obrigatório *</p>
                                    </ng-container>
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label id="label-input" for="text">
                                    <span>Email:</span>
                                    <input required class="input form-control" formControlName="vc_login" type="email"
                                        name="text" id="text" required>
                                    <ng-container *ngIf="formUsuario.controls.vc_login.touched">
                                        <!-- <p class="msg-erro" *ngIf="formUsuario.errors.required">Campo obrigatório *</p> -->
                                        <p class="msg-erro" *ngIf="formUsuario.controls.vc_login.errors">Email inválido
                                            *</p>

                                    </ng-container>
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label id="label-input" for="telefone">
                                    <span>Telefone:</span>
                                    <input formControlName="vc_telefone" class="input form-control"
                                        (input)="onInputChange()" type="text" name="telefone" id="telefone"
                                        mask="00(00) 00000-0000" prefix="+" [showMaskTyped]="false">
                                    <ng-container *ngIf="formUsuario.controls.vc_telefone.touched">
                                        <p class="msg-erro" *ngIf="formUsuario.controls.vc_telefone.errors">Número
                                            inválido *</p>
                                    </ng-container>
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label id="label-input" for="senha">
                                    <span>Senha:</span>
                                    <input formControlName="vc_senha" class="input form-control" type="password"
                                        name="senha" id="senha" required>
                                    <ng-container *ngIf="formUsuario.controls.vc_senha.touched">
                                        <p class="msg-erro" *ngIf="formUsuario.controls.vc_senha.errors">Campo
                                            obrigatório *</p>
                                    </ng-container>
                                </label>
                            </div>

                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <label>
                                    <span>Clientes:</span>
                                </label>
                                <mat-select #selectClientes formControlName="ar_clientes" class="input form-control" multiple>
                                    <mat-select-trigger *ngIf="opcaoTodosClientes.selected">
                                        Todos os clientes
                                    </mat-select-trigger>
                                    <mat-option #opcaoTodosClientes (click)="selecionarService.selecionarTodosClientes(selectClientes, opcaoTodosClientes)">Todos os
                                        clientes</mat-option>
                                    <div *ngFor="let cliente of clientes">
                                        <mat-option [value]="cliente.sr_id" (click)="selecionarService.verificarSelecionarTodos(formUsuario, 'ar_clientes', opcaoTodosClientes, clientes)">{{cliente.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>
                            </div>
                            <div class="col-md-6">
                                <label>
                                    <span>Grupos:</span>
                                </label>
                                <mat-select formControlName="ar_grupos" class="input form-control" multiple>
                                    <div *ngFor="let grupo of grupos">
                                        <mat-option [value]="grupo.sr_id">{{grupo.vc_nome}}</mat-option>
                                    </div>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    <!-- <div id="container-checkbox" for="cliente">
                        <div class="row">
                                <ul>
                                    <div id="checkbox">
                                        <li *ngFor="let cliente of clientes">
                                            <label class="checkbox">
                                                <input type="checkbox" [value]="cliente.sr_id" (change)="onCheckboxChangeCliente($event)" name="clientes">
                                                {{cliente.vc_nome}}
                                            </label>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                        </div> -->
                    <!-- <label id="label-checkbox" for="grupo">
                        <span>Grupos:</span>
                    </label>
                    <div id="container-checkbox">
                        <div class="row">
                            <div class="col">
                                <ul>
                                    <div id="checkbox">
                                        <li *ngFor="let grupo of grupos; let i=index">
                                            <label class="checkbox">
                                                <input type="checkbox" [value]="grupo.sr_id" (change)="onCheckboxChangeGrupo($event)" class="checkbox" name="grupos">
                                                {{grupo.vc_nome}}
                                            </label>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                    <div id="buttons">
                        <button class="btn-sucesso btn btn-lg btn-success" type="submit"
                            [disabled]="!formUsuario.valid">Cadastrar</button>
                        <button routerLink="../" class="btn-cancelar btn btn-lg btn-danger" type="btn">Cancelar</button>
                    </div>
                </form>
            </div>
        </div>

    </div>
    <div class="load" *ngIf="load">
        <mat-progress-spinner diameter=30 class="example-margin" [color]="color" [mode]="mode" [value]="value">
        </mat-progress-spinner>
    </div>
</main>